<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" md="4">
        <b-card v-if="registro_no_encontrado">
          <div slot="header">
            <strong>Empresa no encontrada</strong>
          </div>
        </b-card>
        <b-card no-body :no-block="true" v-else>
          <div slot="header">
            <strong
              >{{
                this.$route.params.id == null ? "Nueva" : "Actualizar"
              }}
              Empresa</strong
            >
          </div>
          <b-card-body>
            <b-form>
              <b-form-group>
                <label class="col-form-label" for="nombre">Nombre</label>
                <input
                  type="text"
                  autocomplete="off"
                  :class="{
                    'form-control is-invalid': errores.nombre,
                    'form-control is-valid': !errores.nombre
                  }"
                  id="nombre"
                  v-model.trim="model.nombre"
                />
                <b-form-invalid-feedback v-if="errores.nombre">{{
                  errores.nombre
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group>
                <label class="col-form-label" for="ruc">RUC:</label>
                <input
                  type="text"
                  autocomplete="off"
                  :class="{
                    'form-control is-invalid': errores.ruc,
                    'form-control is-valid': !errores.ruc
                  }"
                  id="ruc"
                  v-model="model.ruc"
                />
                <b-form-invalid-feedback v-if="errores.ruc">{{
                    errores.ruc
                  }}</b-form-invalid-feedback>
              </b-form-group>


              <b-form-group>
                <label class="col-form-label" for="codigo">Codigo</label>
                <input
                  type="text"
                  autocomplete="off"
                  :class="{
                    'form-control is-invalid': errores.codigo,
                    'form-control is-valid': !errores.codigo
                  }"
                  id="codigo"
                  v-model="model.codigo"
                />
                <b-form-invalid-feedback v-if="errores.codigo">{{
                  errores.codigo
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group>
                <label class="col-form-label" for="mes_cierre_fiscal">Mes de cierre</label>
                <input
                  type="number"
                  min="1"
                  max="12"
                  autocomplete="off"
                  :class="{
                    'form-control is-invalid': errores.mes_cierre_fiscal,
                    'form-control is-valid': !errores.mes_cierre_fiscal
                  }"
                  id="mes_cierre_fiscal"
                  v-model.number="model.mes_cierre_fiscal"
                />
                <b-form-invalid-feedback v-if="errores.mes_cierre_fiscal">{{
                  errores.mes_cierre_fiscal
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group>
                <label class="col-form-label" for="codigo">Activa</label>
                <b-form-select
                  v-model="model.activa"
                  :options="sinoList"
                ></b-form-select>
              </b-form-group>
            </b-form>
          </b-card-body>
          <div slot="footer">
            <a class="btn btn-sm btn-success text-white" @click="guardar()">
              <i class="fa fa-dot-circle-o"></i> Guardar
            </a>
            <router-link
              class="btn btn-sm btn-danger text-white"
              :to="'/Empresas/'"
            >
              <i class="fa fa-ban" /> Cancelar
            </router-link>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "EmpresaForm",
  data() {
    return {
      model: { nombre: null },
      errores: {},
      registro_no_encontrado: null,
      ruta_guardar: "/api/catalogos/empresa-store",
      sinoList:[
        { value: 0, text: 'No' },
        { value: 1, text: 'Si' },
      ]
    };
  },
  created() {
    this.cargar();
  },
  methods: {
    async cargar() {
      if (this.$route.name == "Crear Empresa")
        this.registro_no_encontrado = false;
      else if (this.$route.params.id != null)
        try {
          this.error_nombre = null;
          // eslint-disable-next-line no-undef
          let { data } = await axios.post("/api/catalogos/empresa", {
            id: this.$route.params.id
          });
          if (!data.data) this.registro_no_encontrado = true;
          this.model = data.data;
        } catch (error) {
          console.log(error);
        }
      else this.registro_no_encontrado = true;
    },
    async guardar() {
      try {
        this.errores={};
        // eslint-disable-next-line no-undef
        let { data } = await axios.post(this.ruta_guardar, this.model);
        if (data.status == "fail") this.errores =data.errors;
        else this.$router.push("/empresas");
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
